import React from 'react'
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import FormTitle from '../../../library/form/components/FormTitle';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import { UiGridColTwo, UiCol, UiRow } from "../../../library/layout/Index";

const ProfileIdentityEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '275px' }}
            formStyle={{ width: '640px' }} formTitle={<FormTitle formObject={formObject} value="Profile Identity" />}
        >
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "name" }} value="Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" autofocus className="uiInput"
                                action={{ InputType: "input", paramName: "name" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "dateOfBirth" }} value="Birth Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                        action={{ InputType: "dp", paramName: "dateOfBirth" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "gender" }} value="Gender" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "gender", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} 
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "identityType" }} value="ID Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "identityType", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />

                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "number" }} value="ID Number" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "number" }}
                            />
                        </li>
                        <li>

                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedCountry" }} value="Country" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "issuedCountry", acMethod: "Country" }}
                            />
                        </li>
                        <li>

                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedLocation" }} value="Location" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "issuedLocation" }}
                            />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedOn" }} value="Issued On" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "issuedOn" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "expiryOn" }} value="Expiry On" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "expiryOn" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "hasNoexpiry" }} value="Has No Expiry" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "hasNoexpiry" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Set Default" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isDefault" }} />
                        </li>
                    </ul>
                </UiCol>
                <UiRow>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="82"
                            action={{ paramName: "remarks" }}
                        />
                    </li>
                </UiRow>
            </UiGridColTwo>

        </FormDialog>
    )
}

export default withView(ProfileIdentityEditor, "proId", "proId")